import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate, Navigate } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';
import { setNavigate } from './utils/navigationService';
import { getAccessToken } from './utils/auth';

const AppRoutes = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Store the navigate function for use in non-component files
    setNavigate(navigate);
  }, [navigate]);

  const isLoggedIn = !!getAccessToken();

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/"
        element={isLoggedIn ? <Dashboard /> : <Navigate to="/login" replace />}
      />
    </Routes>
  );
};

const App = () => {
  return (
    <Router>
      <AppRoutes />
    </Router>
  );
};

export default App;


